module.exports = __webpack_public_path__ + "img/characterAnime14.bdd66791.png";